import React, { useState, useEffect, useRef } from 'react'

function EditableCell({ value, onChange, onBlur }) {
  const [editing, setEditing] = useState(false)
  const [tempValue, setTempValue] = useState(value)
  const inputRef = useRef(null)

  useEffect(() => {
    if (editing && inputRef.current) {
      inputRef.current.focus()
      inputRef.current.select()
    }
  }, [editing])

  const handleDoubleClick = () => {
    setTempValue(value)
    setEditing(true)
  }

  const handleBlur = () => {
    setEditing(false)
    if (tempValue !== value) {
      onChange(tempValue)
      if (onBlur) onBlur()
    }
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleBlur()
    } else if (e.key === 'Escape') {
      setTempValue(value)
      setEditing(false)
    }
  }

  if (editing) {
    return (
      <input
        ref={inputRef}
        type="text"
        value={tempValue}
        onChange={(e) => setTempValue(e.target.value)}
        onBlur={handleBlur}
        onKeyDown={handleKeyDown}
        className="cell-input"
      />
    )
  }

  return (
    <div
      className="editable-cell"
      onDoubleClick={handleDoubleClick}
      title={value}
    >
      {value}
    </div>
  )
}

export default EditableCell
